import React from 'react'
import { useTranslation } from 'react-i18next'

import EditWidgetPlaceholder from 'js/page/Widget/components/components/EditWidgetPlaceholder'

import { useSubtypeIsSupported } from '../helpers/supportedSubtypes'
import SettingsType from '../types/SettingsType'

import ButtonView from './components/ButtonView'
import FormView from './components/FormView'

interface Props {
    guid: string
    settings: SettingsType
    editMode?: boolean
}

const CreateContentView = ({ guid, settings, editMode }: Props) => {
    const { t } = useTranslation()

    const { subtype, layout } = settings

    const subtypeIsSupported = useSubtypeIsSupported(layout, subtype)

    if (!subtypeIsSupported) {
        if (!editMode) return null

        return (
            <EditWidgetPlaceholder
                title={t('widget-create-content.title')}
                helper={
                    !!subtype &&
                    t('widget-create-content.content-type-not-supported')
                }
            />
        )
    }

    if (layout === 'button') {
        return <ButtonView settings={settings} />
    } else if (layout === 'form') {
        return <FormView guid={guid} settings={settings} />
    } else {
        return null
    }
}

export default CreateContentView
